import { render, staticRenderFns } from "./CheckpointsPage.vue?vue&type=template&id=6da5c392&"
import script from "./CheckpointsPage.vue?vue&type=script&lang=js&"
export * from "./CheckpointsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports